import type { RouteRecordRaw } from "vue-router";

export const AuthRoutes: RouteRecordRaw[] = [
  {
    path: "/login",
    name: "login",
    component: () => import("@/domain/Auth/presentation/pages/LoginPage.vue"),
  },
  {
    path: "/accept-invitation",
    name: "acceptInvitation",
    component: () => import("@/domain/Auth/presentation/pages/AcceptInvitationPage.vue"),
    meta: { requiresAuth: false },
    props: (route) => ({
      token: route.query.token,
    }),
  },
  {
    path: "/forgot-password",
    name: "forgotPassword",
    component: () => import("@/domain/Auth/presentation/pages/ForgotPasswordPage.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/reset-password",
    name: "resetPassword",
    component: () => import("@/domain/Auth/presentation/pages/ResetPasswordPage.vue"),
    meta: { requiresAuth: false },
    props: (route) => ({
      token: route.query.token,
    }),
  },
];
